import Vue from 'vue'
import App from './App.vue'
import { router } from '@/router'
import VueSocketIO from 'vue-socket.io'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
const {
  VUE_APP_SOCKET_API
} = process.env
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(
  new VueSocketIO({
    debug: false,
    // connection: 'http://localhost:8318',
    connection: VUE_APP_SOCKET_API,
    options: { path: '/so-api/barclay/socket' }
  })
)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
